import { alpha } from '@mui/system';
import { themeObject } from '../../lib';

export const HELP_DESK_SUPPORT_URL = 'https://support.burstiq.com';

export interface HelpDeskModalProps {
    onClose: () => void;
}

export const helpDeskModalStyles = {
    root: {
        '& .MuiDialog-container': {
            '& .MuiPaper-root': {
                overflow: 'hidden',
                height: '320px',
                width: '378px',
                borderRadius: '10px',
                boxShadow: `
                0px 6px 30px 5px ${alpha(themeObject.palette.grayScale[700], 0.12)},
                0px 16px 24px 2px ${alpha(themeObject.palette.grayScale[700], 0.14)},
                0px 8px 10px -5px ${alpha(themeObject.palette.grayScale[700], 0.2)},
                `,
                '#dialog-title-container': {
                    minHeight: '48px',
                },
            },
        },
    },
    dialogContentContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        overflowY: 'hidden',
        minHeight: '165px',
        padding: 0,
    },
    dialogContentText: {
        ...themeObject.typography.body2,
        fontFamily: 'Red Hat Text',
        lineHeight: '15.88px',
        color: themeObject.palette.grayScale[800],
        height: '149px',
        width: '314px',
        mx: 4,
        mt: 2,
        mb: 0,
    },
    dialogContentNoteText: {
        ...themeObject.typography.captions.default,
        color: themeObject.palette.grayScale[800],
    },
    dialogActionContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 0,
        mb: '7px',
    },
    openButton: {
        mt: 2,
    },
    closeButton: {
        mt: 1,
        mb: 2,
    },
};
